/*
 * PIOLET · comportamiento de los componentes de página (piolet-ds.css).
 * Cargado una vez con defer en layout/theme.liquid. Sin dependencias.
 *   [data-pds-tabs]   tabs accesibles (clic, flechas, Inicio, Fin), tabindex itinerante
 *   .pds[data-pds-reveal]  pausa la animación hasta que la sección entra en pantalla (.is-gated → .is-inview)
 *   [data-pds-count]  conteo de números simples (500, 1.35) al entrar en pantalla
 * Con prefers-reduced-motion no se pausa ni se cuenta nada: todo se ve de inmediato.
 * Sin JS: el primer tab se ve completo y las animaciones corren al cargar.
 */
(function () {
  if (window.__pioletDs) return;
  window.__pioletDs = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function activateTab(root, tab, focus) {
    var tabs = root.querySelectorAll('[data-pds-tab]');
    var id = tab.getAttribute('aria-controls');
    each(tabs, function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    each(root.querySelectorAll('[data-pds-panel]'), function (p) {
      var on = p.id === id;
      p.classList.toggle('is-active', on);
      if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
    });
    if (focus) tab.focus({ preventScroll: true });
    var nav = tab.parentNode;
    if (nav && nav.scrollWidth > nav.clientWidth + 2) {
      var left = tab.offsetLeft - 16;
      try { nav.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { nav.scrollLeft = left; }
    }
  }

  function initTabs(root) {
    if (root.__pdsTabs) return;
    root.__pdsTabs = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pds-tab]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activateTab(root, tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); activateTab(root, next, true); }
      });
    });
  }

  function countUp(el) {
    var final = el.textContent;
    var target = parseFloat(final);
    var dec = (final.split('.')[1] || '').length;
    var t0 = null;
    if (isNaN(target)) return;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / 900);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? (target * eased).toFixed(dec) : final;
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function warmImages(root) {
    each(root.querySelectorAll('img[data-pds-warm][loading="lazy"]'), function (img) { img.setAttribute('loading', 'eager'); });
  }

  function onReveal(root) {
    root.classList.add('is-inview');
    warmImages(root);
    if (!reduce) each(root.querySelectorAll('[data-pds-count]'), countUp);
  }

  function initReveal(root) {
    if (root.__pdsReveal) return;
    root.__pdsReveal = true;
    if (reduce || !hasIO) { root.classList.add('is-inview'); warmImages(root); return; }
    root.classList.add('is-gated');
    var target = root.querySelector('[data-pds-reveal-target]') || root;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { io.disconnect(); onReveal(root); }
      });
    }, { threshold: 0.2 });
    io.observe(target);
  }

  function init(scope) {
    each((scope || document).querySelectorAll('[data-pds-tabs]'), initTabs);
    each((scope || document).querySelectorAll('[data-pds-reveal]'), initReveal);
  }

  init(document);

  // Editor de temas: secciones nuevas o recargadas, y seleccionar un bloque abre su tab.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var id = e.detail && e.detail.blockId;
    if (!id) return;
    var tab = document.querySelector('[data-pds-tab][data-block-id="' + id + '"]');
    if (!tab) return;
    var root = tab.closest('[data-pds-tabs]');
    var sec = tab.closest('.pds');
    if (sec) sec.classList.add('is-inview');
    if (root) activateTab(root, tab, false);
  });
})();
